import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { usePartial } from 'shared/hooks/utils';
import { loadLastEvents } from 'console/tabs/events/redux/actions';
import { MaterialDropdown } from 'console/shared/components/fields';
import '../../period/tracking-period.sass';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { EventDesc } from 'console/device/device-event';
import { isExcludedEventType, useNetworkEvent } from 'console/tabs/events/utils';
const options = [10, 20, 50, 100].map((value) => ({
    text: `${value}`,
    value: value,
}));
const all_event_types = Object.keys(EventDesc);
const getExcludedEventTypes = (user_filters, show_network_events) => all_event_types.reduce((accum, type) => {
    if (isExcludedEventType(user_filters, show_network_events, type)) {
        return [...accum, type];
    }
    return accum;
}, []);
export const LastEvents = memo(function LastEvents(props) {
    const { device_id, isActive, onClick } = props;
    const show_network_events = useNetworkEvent();
    const [quantity, setQuantity] = useState(options[0].value);
    const event_filter_by_user = useAppSelector((state) => state.ui_settings.event_filter);
    const onLoadLastEvents = useAction(loadLastEvents);
    const excluded_event_types = useMemo(() => getExcludedEventTypes(event_filter_by_user, show_network_events), [event_filter_by_user, show_network_events]);
    const loadPreviousEvents = usePartial(onLoadLastEvents, device_id, quantity, excluded_event_types);
    useEffect(() => {
        if (isActive) {
            loadPreviousEvents();
        }
    }, [quantity, excluded_event_types]);
    return (_jsxs(Box, { px: 0, display: "flex", alignItems: "center", justifyContent: "space-between", children: [_jsx(Box, { className: "ui-period-widget-button-wrapper", p: 0, onClick: loadPreviousEvents, children: _jsx("span", { className: "ui-tracking-period ui-period-widget-button", onClick: loadPreviousEvents, children: "\u041F\u041E\u041A\u0410\u0417\u0410\u0422\u042C \u041F\u041E\u0421\u041B\u0415\u0414\u041D\u0418\u0415" }) }), _jsx(MaterialDropdown, { options: options, value: quantity, onChange: setQuantity, onClick: onClick, disabled: !isActive, sx: {
                    transform: 'scale(0.8)',
                } })] }));
});
